import { Serializable } from "./serializable";
import { PriceData } from '@/models/experience';

export default class Gift implements Serializable<Gift> {
  payment_token?: string;
  adults?: number;
  adultsGiftQuantity: number;
  priceLabels: PriceData[];
  firstname?: string;
  lastname?: string;
  email?: string;
  phone?: string;
  beneficiary_firstname?: string;
  beneficiary_lastname?: string;
  beneficiary_email?: string;
  beneficiary_notify_at?: string;
  message?: string;
  redeemed?: boolean;
  invoice_data?: string;
  coupon?: string;
  expires_at?: string;
  paypalData?: any;
  privacy_profiling?: boolean;
  privacy_marketing?: boolean;
  provider?: 'paypal' | 'stripe';
  experience?: any;
  tags?: any[];
  default_min_parties: number;
  optional_data: {
    birth_data: string,
    country: any
  }

  localDeserialization(input: any): Gift {
    console.error(input)
    if (input != null) {
      this.payment_token = input.payment_token || null;
      this.adults = input.adults || 0;
      this.adultsGiftQuantity = this.adults || 0;
      this.priceLabels = input.priceLabels || [];
      this.firstname = input.name;
      this.phone = input.phone || input.phoneNumber;
      this.lastname = input.surname;
      this.email = input.email || "";
      this.beneficiary_firstname = input.beneficiary_name || "";
      this.beneficiary_lastname = input.beneficiary_surname || "";
      this.beneficiary_email = input.beneficiary_email || "";
      this.beneficiary_notify_at = input.beneficiaryNotify || "";
      this.message = input.message || "";
      this.redeemed = input.redeemed || false;
      this.invoice_data = input.invoice_data || "";
      this.coupon = input.coupon || "";
      this.expires_at = input.expires_at || "";
      this.paypalData = input.paypalData;
      this.privacy_marketing = input.privacyMarketingAccepted || false;
      this.privacy_profiling = input.privacyProfileAccepted || false;
      this.provider = input.provider;
      this.optional_data = input.optionalData;
      this.default_min_parties = input.default_min_parties;
    }
    return this;
  }

  deserialize(input: any): Gift {
    if (input != null) {
      this.payment_token = input.payment_token || null;
      this.adults = input.adults;
      this.adultsGiftQuantity = this.adults || 0;
      this.priceLabels = input.experience_price_labels || [];
      this.firstname = input.firstname || null;
      this.lastname = input.lastname || null;
      this.email = input.email || null;
      this.phone = input.phone || null;
      this.beneficiary_firstname = input.beneficiary_firstname || null;
      this.beneficiary_lastname = input.beneficiary_lastname || null;
      this.beneficiary_email = input.beneficiary_email || null;
      this.message = input.message || null;
      this.redeemed = input.redeemed || false;
      this.expires_at = input.expires_at || null;
      this.invoice_data = input.invoice_data || null;
      this.coupon = input.coupon || null;
      this.paypalData = input.paypalData || null;
      this.privacy_profiling = input.privacyProfileAccepted;
      this.privacy_marketing =  input.privacyMarketingAccepted;
      this.provider = input.provider;
      this.optional_data = input.optional_data;
      this.default_min_parties = input.default_min_parties;
      this.experience = input.experience || null;
      this.tags = input.tags || [];
    }
    return this;
  }

  requestSerialize(): any {
    return {
      payment_token: this.payment_token,
      adults: this.adults,
      priceLabels: this.priceLabels,
      firstname: this.firstname,
      lastname: this.lastname,
      email: this.email,
      phone: this.phone,
      beneficiary_firstname: this.beneficiary_firstname,
      beneficiary_lastname: this.beneficiary_lastname,
      beneficiary_email: this.beneficiary_email ? this.beneficiary_email.toLowerCase() : null,
      beneficiary_notify_at: this.beneficiary_notify_at,
      message: this.message,
      invoice_data: this.invoice_data ? this.invoice_data : null,
      coupon: this.coupon,
      privacy_profiling: this.privacy_profiling,
      privacy_marketing:  this.privacy_marketing,
      expires_at: this.expires_at,
      paypal_data: this.paypalData
        ? {
            order_id: this.paypalData.orderID,
            authorization_id: this.paypalData.authorizationID
          }
        : null,
      provider: this.provider,
      optional_data: this.optional_data,
      default_min_parties: this.default_min_parties,
      price_labels: this.priceLabels.filter(e=>e.quantity),
    };
  }
}
